var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-app",
        {
          staticStyle: {
            "background-color": "var(--neutral-50)",
            position: "relative"
          },
          style: { top: _vm.showTopWarning ? "40px" : "0" }
        },
        [
          !_vm.isXs
            ? _c(
                "v-btn",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "21px",
                    height: "24px",
                    width: "24px",
                    "z-index": "15",
                    background: "var(--bg-navbar-header)"
                  },
                  style: {
                    border: _vm.borderOpacity(),
                    left: _vm.leftDrawer && !_vm.isHover ? "92px" : "288px"
                  },
                  attrs: { icon: "", elevation: "0", color: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.openLeftNavBar($event)
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        small: "",
                        color: _vm.textColorContrastNavHeader
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            !_vm.leftDrawer
                              ? "mdi-chevron-left"
                              : "mdi-chevron-right"
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _c("v-hover", {
            attrs: { "open-delay": "100", "close-delay": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var hover = ref.hover
                  return [
                    _c(
                      "v-navigation-drawer",
                      {
                        staticClass: "elevation-0",
                        staticStyle: { overflow: "initial" },
                        style: {
                          "z-index": _vm.isXs ? "10" : "6",
                          width:
                            _vm.leftDrawer && !(hover || _vm.navHoverLock)
                              ? "104px"
                              : "300px",
                          top: _vm.showTopWarning ? "40px" : "0"
                        },
                        attrs: {
                          "expand-on-hover": !_vm.isXs,
                          app: "",
                          permanent: !_vm.isXs
                        },
                        on: {
                          transitionend: function($event) {
                            return _vm.setHover(hover)
                          }
                        },
                        model: {
                          value: _vm.leftSmallDrawer,
                          callback: function($$v) {
                            _vm.leftSmallDrawer = $$v
                          },
                          expression: "leftSmallDrawer"
                        }
                      },
                      [
                        _vm.isXs
                          ? _c(
                              "v-list-item",
                              {
                                staticClass: "elevation-0",
                                class: { "bg-primary": _vm.isTransparentLogo },
                                staticStyle: {
                                  height: "64px",
                                  "background-color": "var(--bg-navbar-header)"
                                },
                                attrs: { color: "primary" }
                              },
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "full-center" },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            "max-width": "100%",
                                            "max-height": "72px"
                                          },
                                          attrs: { src: _vm.logoEscritorio }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isXs
                          ? _c(
                              "div",
                              {
                                staticClass: "full-center",
                                class: { "bg-primary": _vm.isTransparentLogo },
                                style: {
                                  // 'border-bottom': '2px solid #EFEEEB',
                                  height: "66px",
                                  width: "100%",
                                  "z-index": "10",
                                  position: "fixed",
                                  padding: "19px 5px",
                                  // 'background-color': 'var(--primary-light)',
                                  "background-color": "var(--bg-navbar-header)",
                                  "border-right": "1px solid #e0e0e0"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "full-center",
                                    style: {
                                      // 'background-color': 'white',
                                      "margin-bottom": "0px"
                                    }
                                  },
                                  [
                                    !_vm.leftDrawer || _vm.navHoverLock || hover
                                      ? _c("img", {
                                          staticStyle: {
                                            "max-width": "100%",
                                            "max-height": "54px"
                                          },
                                          attrs: { src: _vm.logoEscritorio }
                                        })
                                      : _c("img", {
                                          staticStyle: {
                                            "max-width": "100%",
                                            "max-height": "54px",
                                            margin: "0px 10px"
                                          },
                                          attrs: { src: _vm.faviconEscritorio }
                                        })
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "menu-list-actions",
                            style: {
                              // 'max-height': isXs
                              //   ? 'calc(100vh - 74px)'
                              //   : 'calc(100vh - 64px)',
                              height: "100%",
                              "margin-bottom": _vm.isXs ? "0px" : "10px",
                              "overflow-y": "scroll", // auto
                              position: "fixed",
                              "margin-top": _vm.isXs ? "0px" : "65px",
                              width: "100%",
                              // 'padding-right': '7px',
                              "padding-bottom": "100px",
                              "background-color": "var(--bg-navbar)"
                            }
                          },
                          _vm._l(_vm.defaultRoutes, function(r, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "mb-2 mt-2" },
                              [
                                r.group
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-1" },
                                      [
                                        !r.hiddenTitle &&
                                        !(
                                          _vm.leftSmallDrawer &&
                                          _vm.leftDrawer &&
                                          !(hover || _vm.navHoverLock)
                                        )
                                          ? _c(
                                              "h1",
                                              {
                                                staticClass:
                                                  "m-0 mt-5 mb-1 py-1 font-500 uppercase",
                                                staticStyle: {
                                                  "font-size": "11px"
                                                },
                                                style: {
                                                  color: _vm.$setOpacity(
                                                    _vm.textColorContrastNav,
                                                    0.3
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(r.title) + " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(r.routes, function(
                                          itemGroup,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: i + "_" + index,
                                              class: {
                                                "d-flex justify-content-center": !!(
                                                  _vm.leftSmallDrawer &&
                                                  _vm.leftDrawer &&
                                                  !(hover || _vm.navHoverLock)
                                                )
                                              }
                                            },
                                            [
                                              itemGroup
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("ButtonNavbar", {
                                                        attrs: {
                                                          icon: itemGroup.icon,
                                                          name: itemGroup.title,
                                                          hasList: !!(
                                                            itemGroup.subRoutes &&
                                                            itemGroup.subRoutes
                                                              .length
                                                          ),
                                                          value: itemGroup,
                                                          full:
                                                            !_vm.leftDrawer ||
                                                            _vm.navHoverLock ||
                                                            hover,
                                                          selected: _vm.subIsActive(
                                                            "/simulador",
                                                            itemGroup
                                                          ),
                                                          isNew: itemGroup.new,
                                                          noAccessIcon:
                                                            itemGroup.noAccessIcon
                                                        },
                                                        on: {
                                                          clickEvent: function(
                                                            $event
                                                          ) {
                                                            return _vm.showSubMenu(
                                                              itemGroup
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              !!(
                                                itemGroup.subRoutes &&
                                                itemGroup.subRoutes.length
                                              ) &&
                                              (!_vm.leftDrawer ||
                                                _vm.navHoverLock ||
                                                hover)
                                                ? _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.expandSubMenu[
                                                              itemGroup.name
                                                            ],
                                                          expression:
                                                            "expandSubMenu[itemGroup.name]"
                                                        }
                                                      ]
                                                    },
                                                    _vm._l(
                                                      itemGroup.subRoutes,
                                                      function(sr, j) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              i +
                                                              "_" +
                                                              index +
                                                              "_" +
                                                              j,
                                                            staticClass: "mx-2",
                                                            staticStyle: {
                                                              position:
                                                                "relative"
                                                            },
                                                            style: {
                                                              overflow:
                                                                j === 0
                                                                  ? "hidden"
                                                                  : ""
                                                            }
                                                          },
                                                          [
                                                            _c("icon-svg", {
                                                              staticStyle: {
                                                                position:
                                                                  "absolute",
                                                                left: "-8px"
                                                              },
                                                              style: {
                                                                top:
                                                                  j === 0
                                                                    ? "-19px"
                                                                    : "-22px"
                                                              },
                                                              attrs: {
                                                                name:
                                                                  "union-nav-bar",
                                                                size: "42",
                                                                color: _vm.$setOpacity(
                                                                  _vm.textColorContrastNav,
                                                                  0.3
                                                                )
                                                              }
                                                            }),
                                                            sr
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    class: {
                                                                      "mt-1":
                                                                        j === 0
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "ButtonNavbar",
                                                                      {
                                                                        staticClass:
                                                                          "ml-4 py-2",
                                                                        attrs: {
                                                                          icon:
                                                                            sr.icon,
                                                                          name:
                                                                            sr.title,
                                                                          full:
                                                                            !_vm.leftDrawer ||
                                                                            _vm.navHoverLock ||
                                                                            hover,
                                                                          value: sr,
                                                                          selected: _vm.subIsActive(
                                                                            "/simulador",
                                                                            sr
                                                                          ),
                                                                          sm: ""
                                                                        },
                                                                        on: {
                                                                          clickEvent: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.subRouteGoto(
                                                                              sr
                                                                            )
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _c(
                                      "div",
                                      {
                                        class: {
                                          "d-flex justify-content-center": !!(
                                            _vm.leftSmallDrawer &&
                                            _vm.leftDrawer
                                          )
                                        }
                                      },
                                      [
                                        r
                                          ? _c(
                                              "div",
                                              {
                                                on: {
                                                  mouseover: function(v) {
                                                    return _vm.showSubMenuSuspended(
                                                      v,
                                                      r
                                                    )
                                                  },
                                                  mouseleave:
                                                    _vm.closeSubMenuSuspended
                                                }
                                              },
                                              [
                                                _c("ButtonNavbar", {
                                                  staticClass: "px-3 py-3",
                                                  attrs: {
                                                    icon: r.icon,
                                                    name: r.title,
                                                    value: r,
                                                    full:
                                                      !_vm.leftDrawer ||
                                                      _vm.navHoverLock ||
                                                      hover,
                                                    selected: _vm.subIsActive(
                                                      "/simulador",
                                                      r
                                                    )
                                                  },
                                                  on: {
                                                    clickEvent: function(
                                                      $event
                                                    ) {
                                                      return _vm.goTo(r.name, r)
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                _c("div", { staticClass: "divider-nav-bar" }),
                                false
                                  ? _c(
                                      "v-list-item",
                                      {
                                        class: {
                                          // 'elevation-5': subIsActive('/simulador', r),
                                          "active-menu-path": _vm.subIsActive(
                                            "/simulador",
                                            r
                                          )
                                        },
                                        staticStyle: { "margin-right": "5px" },
                                        attrs: { link: "" },
                                        on: {
                                          click: [
                                            function($event) {
                                              if (
                                                $event.ctrlKey ||
                                                $event.shiftKey ||
                                                $event.altKey ||
                                                $event.metaKey
                                              ) {
                                                return null
                                              }
                                              return _vm.goTo(r.name, r)
                                            },
                                            function($event) {
                                              if (!$event.ctrlKey) {
                                                return null
                                              }
                                              if (
                                                $event.shiftKey ||
                                                $event.altKey ||
                                                $event.metaKey
                                              ) {
                                                return null
                                              }
                                              return _vm.goToCtrl(r.name, r)
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          {
                                            staticClass: "mr-2",
                                            attrs: { title: r.title }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _c("icon-svg", {
                                                  style: {
                                                    color: _vm.subIsActive(
                                                      "/simulador",
                                                      r
                                                    )
                                                      ? "var(--text-navbar-active)"
                                                      : "currentColor"
                                                  },
                                                  attrs: { name: r.icon }
                                                }),
                                                r.new
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          bottom: "-8px",
                                                          right: "-28px"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-chip",
                                                          {
                                                            staticStyle: {
                                                              color: "white"
                                                            },
                                                            attrs: {
                                                              "x-small": "",
                                                              color: "primary"
                                                            }
                                                          },
                                                          [_vm._v(" novo ")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                r.beta
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          bottom: "-8px",
                                                          right: "-28px"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-chip",
                                                          {
                                                            staticStyle: {
                                                              color: "white"
                                                            },
                                                            attrs: {
                                                              "x-small": "",
                                                              color: "primary"
                                                            }
                                                          },
                                                          [_vm._v(" beta ")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              { staticClass: "mb-0" },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(r.title) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        r.second_icon
                                          ? _c(
                                              "v-list-item-action",
                                              {
                                                staticStyle: {
                                                  "margin-right": "5px"
                                                }
                                              },
                                              [
                                                _c("icon-svg", {
                                                  attrs: {
                                                    name: r.second_icon,
                                                    color: _vm.subIsActive(
                                                      "/simulador",
                                                      r
                                                    )
                                                      ? "primary"
                                                      : "currentColor"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        r.actions && r.actions.length
                                          ? _c(
                                              "v-list-item-action",
                                              {
                                                staticStyle: {
                                                  "margin-left": "2px"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.expandSubMenu[
                                                          r.name
                                                        ] = !_vm.expandSubMenu[
                                                          r.name
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("icon-svg", {
                                                      attrs: {
                                                        name: _vm.expandSubMenu[
                                                          r.name
                                                        ]
                                                          ? "mdi-chevron-up"
                                                          : "mdi-chevron-down"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.leftDrawer
                                  ? _c(
                                      "v-expand-transition",
                                      { key: r.name + "expansive-list" },
                                      [
                                        r.actions && r.actions.length
                                          ? _c(
                                              "v-list",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.expandSubMenu[r.name],
                                                    expression:
                                                      "expandSubMenu[r.name]"
                                                  }
                                                ],
                                                staticStyle: {
                                                  "background-color":
                                                    "rgba(255, 255, 255, 0.1)",
                                                  margin: "0px 10px 10px",
                                                  "border-radius": "12px"
                                                },
                                                attrs: { dense: "" }
                                              },
                                              [
                                                _c(
                                                  "v-subheader",
                                                  {
                                                    staticClass:
                                                      "text-heading-small-medium text-color-900 font-medium"
                                                  },
                                                  [_vm._v(" Gatilhos Rápidos ")]
                                                ),
                                                _vm._l(r.actions, function(
                                                  act
                                                ) {
                                                  return _c(
                                                    "v-list-item",
                                                    {
                                                      key: act.tile,
                                                      attrs: { link: "" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.doAction(
                                                            act
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-action",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "icon-svg",
                                                            {
                                                              attrs: {
                                                                name:
                                                                  act.icon || ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    act.icon
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    act.title
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                })
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "v-app-bar",
            {
              staticStyle: {
                "z-index": "5",
                "box-shadow": "none",
                left: "0",
                "padding-left": "120px"
              },
              style: {
                top: _vm.showTopWarning ? "40px" : "0",
                backgroundColor: _vm.bgColorByFlag,
                borderBottom: _vm.borderBottomByFlag
              },
              attrs: { app: "" }
            },
            [
              _vm.isXs
                ? _c("v-app-bar-nav-icon", {
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.leftSmallDrawer = !_vm.leftSmallDrawer
                      }
                    }
                  })
                : _vm._e(),
              !_vm.isXs && !_vm.$currentUser().IS_CLIENTE
                ? _c(
                    "div",
                    {
                      staticClass: "ml-1 mr-5 full-center flex-row",
                      class: {
                        "d-none": !_vm.showCurrentClient
                      },
                      staticStyle: { width: "34%" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "v-application" },
                        [
                          _vm.historicoClientes.length
                            ? _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "open-on-hover": "",
                                    "close-on-click": false,
                                    "nudge-width": 200,
                                    "offset-y": ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { text: "" }
                                                },
                                                on
                                              ),
                                              [
                                                _c("div", [
                                                  _c("small", [
                                                    _vm._v(" Últimos "),
                                                    _c("br"),
                                                    _vm._v(" acessados ")
                                                  ])
                                                ]),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "primary" }
                                                  },
                                                  [_vm._v("mdi-chevron-down")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1870356985
                                  )
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "p-10",
                                      attrs: { width: "500" }
                                    },
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          staticStyle: {
                                            "background-color": "transparent"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-slide-group",
                                            {
                                              key: _vm.keySlideGroup,
                                              attrs: {
                                                "show-arrows":
                                                  _vm.historicoClientes.length >
                                                  3
                                              },
                                              model: {
                                                value: _vm.slideHistory,
                                                callback: function($$v) {
                                                  _vm.slideHistory = $$v
                                                },
                                                expression: "slideHistory"
                                              }
                                            },
                                            _vm._l(
                                              _vm.historicoClientes,
                                              function(cliente) {
                                                return _c("v-slide-item", {
                                                  key: "h-" + cliente.id,
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "v-tooltip",
                                                              {
                                                                attrs: {
                                                                  bottom: ""
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "activator",
                                                                      fn: function(
                                                                        ref
                                                                      ) {
                                                                        var on =
                                                                          ref.on
                                                                        return [
                                                                          _c(
                                                                            "BaseButton",
                                                                            _vm._g(
                                                                              {
                                                                                staticClass:
                                                                                  "mr-1",
                                                                                style: {
                                                                                  "white-space":
                                                                                    "normal"
                                                                                },
                                                                                attrs: {
                                                                                  dark:
                                                                                    "",
                                                                                  outline:
                                                                                    "",
                                                                                  small:
                                                                                    ""
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.selectClient(
                                                                                      cliente
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.getInitials(
                                                                                      cliente.name
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                )
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        cliente.name
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("v-autocomplete", {
                            ref: "campo",
                            staticClass:
                              "mb-0 mr-2 search-field input short-search no-append-inner",
                            staticStyle: { "background-color": "#f1eff2" },
                            attrs: {
                              placeholder: "Pesquisar outro cliente",
                              dense: "",
                              "hide-details": "",
                              filled: "",
                              "full-width": "",
                              "background-color": "#F1EFF2",
                              "append-outer-icon": "mdi-magnify",
                              "append-icon": " ",
                              items: _vm.clientes,
                              "item-value": "id",
                              "item-text": "name",
                              label: "",
                              autocomplete: "off",
                              filter: _vm.customFilter
                            },
                            on: { change: _vm.search },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function(data) {
                                    return [
                                      _c(
                                        "v-list-item-content",
                                        {
                                          staticStyle: {
                                            display: "table-column"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticStyle: {
                                                padding: "5px",
                                                "align-items": "center"
                                              }
                                            },
                                            [
                                              !data.item.id_cadastro_cliente
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        right: "",
                                                        color: "primary"
                                                      }
                                                    },
                                                    [_vm._v(" mdi-account ")]
                                                  )
                                                : _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        right: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " mdi-account-switch "
                                                      )
                                                    ]
                                                  ),
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "0px",
                                                    "margin-left": "5px"
                                                  }
                                                },
                                                [_vm._v(_vm._s(data.item.name))]
                                              )
                                            ],
                                            1
                                          ),
                                          _c("v-row", [
                                            _c(
                                              "small",
                                              {
                                                staticClass: "text-secondary",
                                                staticStyle: {
                                                  "margin-left": "15px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.emailDoCliente(
                                                      data.item
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1330077255
                            ),
                            model: {
                              value: _vm.searchClientTxt,
                              callback: function($$v) {
                                _vm.searchClientTxt = $$v
                              },
                              expression: "searchClientTxt"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              !_vm.$currentUser().IS_CLIENTE
                ? _c(
                    "v-toolbar-title",
                    {
                      staticClass: "full-center flex-row",
                      class: {
                        "d-none": !_vm.showCurrentClient
                      }
                    },
                    [
                      !_vm.$currentClient().name
                        ? _c(
                            "small",
                            {
                              staticClass: "text-secondary",
                              staticStyle: { "font-size": "0.75rem" }
                            },
                            [_vm._v(" Nenhum cliente selecionado ")]
                          )
                        : _vm._e(),
                      _vm.$currentClient().name
                        ? _c(
                            "div",
                            { staticClass: "full-center align-items-baseline" },
                            [
                              _c(
                                "small",
                                { staticStyle: { "font-size": "0.75rem" } },
                                [_vm._v("Você está em:")]
                              ),
                              _c("v-hover", {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var hover = ref.hover
                                        return [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "text-bold mb-0",
                                                  staticStyle: {
                                                    "font-size": "0.95rem"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$currentClient()
                                                          .name
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _vm.$isWhitelabel() &&
                                              !_vm.$currentUser().IS_CLIENTE
                                                ? _c("v-slide-y-transition", [
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: hover,
                                                            expression: "hover"
                                                          }
                                                        ],
                                                        staticStyle: {
                                                          position: "absolute",
                                                          top: "75px",
                                                          left: "50%",
                                                          transform:
                                                            "translate(-50%, -50%)"
                                                        }
                                                      },
                                                      [
                                                        _c("LineProcess", {
                                                          attrs: {
                                                            hideDescription: ""
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2958701213
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-1",
                          staticStyle: { "margin-top": "auto" },
                          attrs: { icon: "", small: "" },
                          on: {
                            click: function($event) {
                              _vm.openMyData(_vm.$currentClient())
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "primary" } },
                            [_vm._v("mdi-pencil")]
                          )
                        ],
                        1
                      ),
                      _vm.$currentClient().name &&
                      !_vm.isXs &&
                      !_vm.$currentUser().IS_CLIENTE &&
                      _vm.$isWhitelabel()
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ml-4",
                              attrs: { text: "" },
                              on: { click: _vm.openResumo }
                            },
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "elevation-2",
                                  attrs: { color: "primary", size: "30" }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white", small: "" } },
                                    [_vm._v("mdi-plus")]
                                  )
                                ],
                                1
                              ),
                              _c("small", { staticClass: "ml-2" }, [
                                _vm._v("Resumo do cliente")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "div",
                {
                  staticClass: "full-center flex-row",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  !_vm.$currentUser().IS_CLIENTE
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            "aria-label":
                              "Buscar páginas, ações ou clientes (Ctrl+K)"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openGlobalSearch($event)
                            }
                          }
                        },
                        [
                          _c("icon-svg", {
                            attrs: { name: "mdi-magnify", color: _vm.colorBell }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "text-heading-small-medium",
                      style: { color: _vm.colorBell }
                    },
                    [_vm._v(" " + _vm._s(_vm.dateStr) + " ")]
                  ),
                  _vm.showNotifications
                    ? _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return (function() {
                                _vm.drawer = !_vm.drawer
                                _vm.lerTodosComunicados()
                              })($event)
                            }
                          }
                        },
                        [
                          _c("icon-svg", {
                            attrs: { name: "bell", color: _vm.colorBell }
                          }),
                          _vm.qtdNotRead
                            ? _c(
                                "div",
                                {
                                  staticClass: "elevation-2",
                                  staticStyle: {
                                    position: "absolute",
                                    top: "-10px",
                                    right: "6px",
                                    background: "var(--primary)",
                                    color: "white",
                                    "border-radius": "20px",
                                    padding: "0px 4px 3px"
                                  }
                                },
                                [
                                  _c("small", [
                                    _vm._v(" " + _vm._s(_vm.qtdNotRead) + " ")
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-fab-transition",
                    [
                      _c(
                        "v-tooltip",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _vm.$store.getters[
                                    "consolidator/cotizacaoLoading"
                                  ]
                                    ? _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "text-primary",
                                            attrs: { icon: "" }
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-progress-circular", {
                                            attrs: {
                                              title:
                                                "A rentabilidade da sua carteira está sendo calculada.",
                                              indeterminate: "",
                                              color: "primary",
                                              size: "25"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " A rentabilidade da carteira está sendo calculada "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-fab-transition",
                    [
                      _vm.hasErrorAccounts && _vm.usuarioAtual.IS_CLIENTE
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              staticClass: "text-danger",
                                              attrs: { icon: "" },
                                              on: { click: _vm.goToAccounts }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-reload-alert")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1013045050
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " Não foi possível atualizar todos os seus dados. "
                                ),
                                _c("br"),
                                _vm._v(" Clique aqui para visualizar. ")
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-menu",
                    {
                      ref: "menu_profile",
                      attrs: {
                        "nudge-width": 200,
                        "close-on-content-click": true,
                        "offset-x": "",
                        left: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "div",
                                [
                                  !_vm.isXs
                                    ? _c(
                                        "v-btn",
                                        _vm._g({ attrs: { text: "" } }, on),
                                        [
                                          _c("ProfessionalAvatar", {
                                            attrs: {
                                              professional: _vm.$currentUser(),
                                              avatarUrl: _vm.$currentUser()
                                                .avatar_url,
                                              textSize: "16px"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-heading-small ml-3/4rem",
                                              style: { color: _vm.colorBell }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$currentUser().nome
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-1",
                                              attrs: { color: "primary" }
                                            },
                                            [_vm._v(" mdi-chevron-down ")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.isXs
                                    ? _c(
                                        "v-btn",
                                        _vm._g(
                                          { attrs: { icon: "", small: "" } },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-dots-vertical")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.menu,
                        callback: function($$v) {
                          _vm.menu = $$v
                        },
                        expression: "menu"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    {
                                      staticClass: "avatar-clickable",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openAvatarUpload($event)
                                        }
                                      }
                                    },
                                    [
                                      _c("ProfessionalAvatar", {
                                        attrs: {
                                          professional: _vm.$currentUser(),
                                          avatarUrl: _vm.$currentUser()
                                            .avatar_url,
                                          textSize: "16px"
                                        }
                                      }),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "avatar-camera-icon",
                                          attrs: {
                                            "x-small": "",
                                            color: "white"
                                          }
                                        },
                                        [_vm._v(" mdi-camera ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "text-heading-small" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.nomeUsuario || "Usuário"
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _vm.usuarioAtual.IS_ASSESSOR
                                        ? _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "text-heading-small-medium"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.usuarioAtual.escritorio
                                                      .nome || ""
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider", {
                            style: {
                              display: "block",
                              border: "solid",
                              "border-width": "thin 0 0 0",
                              "margin-top": "0px",
                              "margin-bottom": "0px",
                              "border-color": "rgba(0,0,0,.12)",
                              background:
                                "radial-gradient(50% 50% at 50% 50%, #B7E1A7 0%, rgba(94, 114, 102, 0) 100%);"
                            }
                          }),
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-subtitle", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-dark",
                                            style: {
                                              "font-size": "0.75rem !important"
                                            },
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: { click: _vm.openMeusDados }
                                          },
                                          [_vm._v(" Meus dados ")]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.canShowChavesApi
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-subtitle", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "text-dark",
                                                style: {
                                                  "font-size":
                                                    "0.75rem !important"
                                                },
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: { click: _vm.openChavesApi }
                                              },
                                              [_vm._v(" Chaves de API ")]
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.$access[_vm.FEATURES.TRANSCRICOES] &&
                              !_vm.usuarioAtual.IS_CLIENTE
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-subtitle", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "text-dark",
                                                style: {
                                                  "font-size":
                                                    "0.75rem !important"
                                                },
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: _vm.openExtensaoAawz
                                                }
                                              },
                                              [_vm._v(" Extensão AAWZ ")]
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticStyle: {
                                            "padding-bottom": "5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "text-dark",
                                              style: {
                                                "font-size":
                                                  "0.75rem !important"
                                              },
                                              attrs: {
                                                href: "javascript:void(0)"
                                              },
                                              on: { click: _vm.openSuggest }
                                            },
                                            [
                                              _vm._v(
                                                " Enviar sugestão/dúvida/problema "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-subtitle", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-dark",
                                            style: {
                                              "font-size": "0.75rem !important"
                                            },
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: { click: _vm.openAlterarSenha }
                                          },
                                          [_vm._v(" Alterar senha ")]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              (_vm.usuarioAtual.IS_CLIENTE
                              ? _vm.usuarioAtual.perfis_disponiveis.includes(
                                  "profissional"
                                )
                              : (_vm.usuarioAtual.perfis_disponiveis || [])
                                  .length > 1)
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                ref: "selectPerfil",
                                                staticClass: "text-secondary",
                                                attrs: {
                                                  value: _vm.formatType(
                                                    _vm.usuarioAtual
                                                      .tipo_usuario
                                                  ),
                                                  items: _vm.formattedPerfis,
                                                  "item-value": "",
                                                  "item-text": _vm.formatType,
                                                  color: "secondary",
                                                  label: "Tipo de perfil",
                                                  dense: "",
                                                  flat: "",
                                                  "hide-details": ""
                                                },
                                                on: { change: _vm.changePerfil }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            {
                              style: {
                                padding: "16px"
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-primary text-bold text-italic",
                                  style: {
                                    "font-size": "0.75rem !important"
                                  },
                                  attrs: { href: "javascript:void(0)" },
                                  on: { click: _vm.logout }
                                },
                                [_vm._v(" Sair ")]
                              ),
                              _c("v-spacer"),
                              _c(
                                "svg",
                                {
                                  style: {
                                    "align-self": "flex-end",
                                    "margin-top": "20px",
                                    opacity: 0.3
                                  },
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "62.129",
                                    height: "16.857",
                                    viewBox: "0 0 62.129 16.857"
                                  }
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "logo_top",
                                        transform: "translate(-23.9 -20)"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "fill",
                                        attrs: {
                                          d:
                                            "M30.967 20h1.188l6.951 16.857h-1.158l-2.23-5.416h-8.429l-2.23 5.416H23.9zm4.4 10.543L31.6 21.014h-.058l-3.91 9.529z"
                                        }
                                      }),
                                      _c("path", {
                                        staticClass: "fill",
                                        attrs: {
                                          d:
                                            "M81.438 20h1.188l6.951 16.857h-1.158l-2.23-5.416h-8.4l-2.23 5.416H74.4zm4.432 10.543l-3.77-9.529h-.058l-3.91 9.529z",
                                          transform: "translate(-35.873)"
                                        }
                                      }),
                                      _c("path", {
                                        staticClass: "fill",
                                        attrs: {
                                          d:
                                            "M193.324 20h12.339v.9L193.73 35.959h12.136v.9H192.6v-.9L204.475 20.9h-11.151z",
                                          transform: "translate(-119.837)"
                                        }
                                      }),
                                      _c("path", {
                                        staticClass: "fill",
                                        attrs: {
                                          d:
                                            "M111.829 20.592a.217.217 0 0 1-.029-.145c0-.232.116-.348.377-.348h1.68c.174 0 .261.087.319.261l4.692 13.208 3.476-6.112a1.417 1.417 0 0 1 .348-.377.862.862 0 0 1 .434-.145h.985a1.083 1.083 0 0 1 .434.145.685.685 0 0 1 .319.377l4.75 8.66c.029.029.029.058.029.116 0 .087-.058.116-.145.116h-1.188a.862.862 0 0 1-.434-.145.88.88 0 0 1-.348-.377l-3.939-6.951-3.939 6.951a.825.825 0 0 1-.782.492h-1.13c-.174 0-.261-.087-.319-.261z",
                                          transform: "translate(-62.44 -.071)"
                                        }
                                      }),
                                      _c("path", {
                                        staticClass: "fill",
                                        attrs: {
                                          d:
                                            "M172.406 33.54a.254.254 0 0 1-.261.2.3.3 0 0 1-.232-.116l-.956-1.709a.681.681 0 0 1-.058-.232c0-.087 0-.116.029-.145l3.563-11.035a.654.654 0 0 1 .145-.319.354.354 0 0 1 .261-.087h1.477a.489.489 0 0 1 .145.058c.058.029.087.087.087.2a.217.217 0 0 1-.029.145z",
                                          transform: "translate(-104.422 -.071)"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.showNotifications
            ? _c(
                "v-navigation-drawer",
                {
                  attrs: {
                    fixed: "",
                    app: "",
                    temporary: "",
                    right: "",
                    dark: "",
                    width: "300px",
                    color: "#2d212f"
                  },
                  model: {
                    value: _vm.drawer,
                    callback: function($$v) {
                      _vm.drawer = $$v
                    },
                    expression: "drawer"
                  }
                },
                [
                  _c(
                    "v-list",
                    {
                      staticClass: "elevation-10",
                      attrs: { color: "#2d212f" }
                    },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm._v(" Minhas notificações "),
                                  _vm.qtdNotRead
                                    ? _c("strong", [
                                        _vm._v(
                                          " (" + _vm._s(_vm.qtdNotRead) + ") "
                                        )
                                      ])
                                    : _vm._e(),
                                  _c("v-spacer"),
                                  _vm.notificacoes.length
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "secondary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.goTo("notifications")
                                            }
                                          }
                                        },
                                        [_vm._v(" Ver todas ")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _vm.usuarioAtual.IS_CLIENTE
                    ? _c(
                        "v-list",
                        {
                          staticStyle: {
                            "max-height": "calc(100vh - 80px)",
                            overflow: "auto"
                          },
                          attrs: {
                            nav: "",
                            "three-line": "",
                            color: "#2d212f",
                            dense: ""
                          }
                        },
                        _vm._l(_vm.notificacoes, function(item) {
                          return _c(
                            "v-list-item",
                            {
                              key: "comunicado-" + item.id,
                              attrs: { link: "" },
                              on: {
                                click: function($event) {
                                  return _vm.expandirComunicado(item)
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    {
                                      staticStyle: { color: "var(--primary)" }
                                    },
                                    [_vm._v(" " + _vm._s(item.nome) + " ")]
                                  ),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(" " + _vm._s(item.conteudo[0]) + " ")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  !_vm.usuarioAtual.IS_CLIENTE
                    ? _c(
                        "v-list",
                        {
                          staticStyle: {
                            "max-height": "calc(100vh - 80px)",
                            overflow: "auto"
                          },
                          attrs: {
                            nav: "",
                            "three-line": "",
                            color: "#2d212f",
                            dense: ""
                          }
                        },
                        _vm._l(_vm.notificacoes, function(item) {
                          return _c(
                            "v-list-item",
                            {
                              key: "noty-" + item.id,
                              staticClass: "elevation-2",
                              attrs: { link: "" },
                              on: {
                                click: function($event) {
                                  return _vm.expandirNotificacao(item)
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    {
                                      class:
                                        _vm.TIPOS_NOTIFICACOES[item.tipo] ||
                                        _vm.TIPOS_NOTIFICACOES["default"]
                                    },
                                    [_vm._v(" " + _vm._s(item.titulo) + " ")]
                                  ),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.formatCorpo(item.corpo)) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-content",
            {
              style: {
                "padding-left": _vm.isSmall
                  ? "0"
                  : _vm.leftDrawer
                  ? "104px"
                  : "300px"
              }
            },
            [
              _c(
                "v-container",
                {
                  staticClass: "p-0 m-0",
                  staticStyle: {
                    "max-width": "100%",
                    overflow: "auto",
                    "max-height": "calc(100vh - 64px)"
                  }
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "min-height": "70vh",
                          "padding-bottom": "100px"
                        }
                      },
                      [_vm._t("default")],
                      2
                    )
                  ])
                ]
              )
            ],
            1
          ),
          !_vm.usuarioAtual.IS_CLIENTE && !_vm.isWhitelabel
            ? _c(
                "v-system-bar",
                {
                  staticStyle: {
                    "background-color": "var(--green)",
                    cursor: "pointer"
                  },
                  attrs: { app: "" },
                  on: { click: _vm.goToContrato }
                },
                [
                  _c("v-spacer"),
                  !_vm.isXs
                    ? _c("p", { staticClass: "mb-0 text-dark" }, [
                        _vm._v(" Contrate "),
                        _c("strong", [_vm._v("plataforma White Label")]),
                        _vm._v(
                          " e entregue sua marca e suas cores para seu cliente. "
                        )
                      ])
                    : _c(
                        "p",
                        {
                          staticClass: "mb-0 text-dark",
                          staticStyle: { "font-size": "0.65rem" }
                        },
                        [
                          _vm._v(
                            " Entregue sua marca e suas cores para seu cliente. "
                          )
                        ]
                      ),
                  _c("v-spacer"),
                  _c(
                    "a",
                    {
                      staticClass: "text-dark",
                      style: {
                        "font-size": _vm.isXs
                          ? "0.65rem !important"
                          : "0.85rem !important",
                        "text-decoration": "underline",
                        "font-weight": "bold"
                      },
                      attrs: { href: "javascript:void(0)" }
                    },
                    [_vm._v(" Contratar ")]
                  ),
                  _c("v-spacer")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.$route &&
      _vm.$route.name &&
      !_vm.$route.name.includes("carteira.") &&
      !_vm.$route.name.startsWith("clientes")
        ? _c("LeftBar")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }